/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (window.boostSDAppConfig) {
  window.boostSDAppConfig.integration =  Object.assign({
    wishlists: 'king'
  }, window.boostSDAppConfig.integration || {});
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
   (componentRegistry) => {
      componentRegistry.useComponentPlugin('FilterOption', {
         name: 'Lowercase all filter option values',
         apply: () => ({
            props: (props) => {
               if (props.option.displayType == "range") return props; // Exclude range slider

               let ids = ["pf_pc_product_category"]; // Apply to specific filter option
               if (ids.includes(props.option.filterOptionId)) { // Remove this if apply to all filter options
                  const newValues = props.option.values?.map(item => {
                     return {
                        ...item,
                        label: (item.label || item.key)?.toLowerCase(),
                        displayName: (item.displayName || item.key)?.toLowerCase(),
                     }
                  })
                  props.option.values = newValues;
               }
               return props;
            },
         }),
      });
   }
]);

const customize = {
  updateFilterOptionValue: (componentRegistry) => {
      componentRegistry.useComponentPlugin('FilterOption', {
         name: 'Update filter option value #230231',
         apply: () => ({
            props: (props) => {

               let ids = ["pf_t_gender"]; // Apply to specific filter option
               if (ids.includes(props.option.filterOptionId)) { // Remove this if apply to all filter options
                  const newValues = props.option.values?.map(item => {
                     return {
                        ...item,
                        label: (item.label || item.key)?.replace('_J', '').replace('_W', ''),
                        displayName: (item.displayName || item.key)?.replace('_J', '').replace('_W', ''),
                     }
                  })
                  props.option.values = newValues;
               }
               return props;
            },
         }),
      });
   },
  updateRefineByValue: (componentRegistry) => {
      componentRegistry.useComponentPlugin('RefineByVertical', {
         name: 'Update refined by value #230231',
         apply: () => ({
            props: (props) => {

               let ids = ["pf_t_gender"]; // Apply to specific filter option
              console.log(props);
              for (let index = 0; index < props.refineByData.length; index++) {
                if (ids.includes(props.refineByData[index].filterOptionId)) { // Remove this if apply to all filter options
                  const newValue = props.refineByData[index].value.replace('_J', '').replace('_W', '');
                  props.refineByData[index].value = newValue;
               }
              }
               
               return props;
            },
         }),
      });
   },  
   updateProductItemGrid: (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductItem', {
         name: 'Add custom vendor #228955',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                  const productData = element.getParams().props.product;
                  const productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  const productItem = document.querySelector('[data-product-id="' + productId + '"]');
                  const productVendor = productData.tags.find(tag => tag.startsWith('Brand_'))?.replace('Brand_', '');
                  if (productItem && !productItem.querySelector('.boost-sd__info-vendor') && productVendor) {
                    const vendorHTML = `<h5 class="product_brand boost-sd__info-vendor">${productVendor}</h5>`;
                    productItem.querySelector('.boost-sd__product-title').insertAdjacentHTML('beforebegin', vendorHTML);
                  }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.warn(e);
               }
            }
         }),
      });
   }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.updateProductItemGrid,
  customize.updateFilterOptionValue,
  customize.updateRefineByValue
]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'ProductList - call get Products Data',
            apply() {
                return {
                    async afterRender(element) {
                        let productHandle = '';
                        if (element.getParams().props && element.getParams().props.product) {
                            productHandle = element.getParams().props.product.handle;
                        }
                        let ajaxUrl = Shopify.routes.root + 'products/' + productHandle + '?view=boost-pfs-integration';
                        if(jQuery){
                          jQuery.get(ajaxUrl,function(res_success){
                              let res = JSON.parse(res_success);
                              let productItem = document.querySelector(`.boost-sd__product-item[data-product-id="` + res.id + `"] `);
                               if (!productItem.querySelector('.SI_trigger')) {
                                 productItem.insertAdjacentHTML('beforeend', res.notifyMeButton);
                               }
                          });
                        }
                        
                    },
                };
            },
        });
    }
]);